import React from 'react';
import { Helmet } from "react-helmet";
import { useParams } from 'react-router-dom';
import { careerItem } from './data';
import { useState, useEffect, useRef } from 'react';
import { base_url_url } from "../../igtComponant/Links";
import { Link } from 'react-router-dom';
import axios from 'axios'; 

export const SingleCareer = () => {
    const [data, setData] = useState([]);
    const [formName, setName] = useState();
    const [formEmail, setEmail] = useState();
    const [formPhone, setPhone] = useState();
    const [formHearAbout, setHearAoout] = useState();
    const [fileData, setFileData] = useState();
    const [formExperience, setExperience] = useState();
    const [formApplyFor, setApplyFor] = useState();

    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [formLoading, setFormLoading] = useState(false);

    useEffect(() => {
        setData(careerItem[id]);
    }, [id]);

    const { title, icon, experience, location, skills } = data;

    const form = useRef();
    const [formmessage, setFormMessage] = useState("");

    const sendEmail = (e) => {
        e.preventDefault();
        setFormLoading(true);
        const formData = new FormData();
        
        formData.append("file-871", fileData);
        formData.append('your-name', formName);
        formData.append('your-email', formEmail);
        formData.append('your-phone', formPhone);
        formData.append('hear-about-us', formHearAbout);
        formData.append('your-message', formExperience);
        formData.append('applyingfor', title);
        formData.append('your-subject', 'Appying For Career | '+title);
        formData.append('subject', 'Appying For Career | '+title);
        formData.append('formType', 1);
        
       fetch('https://www.igtechso.com/IGT-Contact/wp-json/contact-form-7/v1/contact-forms/9/feedback', {
           method: 'POST',
           body: formData,
           
       }).then( res => res.json() ).then( data => {
           if(data.status == "mail_sent"){
                setFormMessage('<p className="success">Mail is sent successfully. We will contact you soon.<p>');
                clearForm();
           }else{
                setFormMessage('<p className="faild">Mail is sent is failed.<p>');
           }
        
       }).catch( error => console.log( error ) );

    };

    const clearForm = () =>{
        setName("");
        setEmail("");
        setPhone("");
        setHearAoout("");
        setFileData("");
        setExperience("");
        setFormLoading(false);
        setTimeout(()=>{
            setFormMessage("");
        },10000)
    }

    const fileChangeHandler = (e) => {
        setFileData(e.target.files[0]);
    };

    setTimeout(() => {
        setLoading(true);
    }, 300);
    return (
        <>
            <Helmet>
                <base href={process.env.PUBLIC_URL}> </base>
                <title>{title}</title>
                <link rel="canonical" href={`${process.env.PUBLIC_URL}/blog/${id}`}></link>
                <meta name="description" content="IGT" />
                <meta name="keywords" content="IGT" />
                <meta name="author" content="IGT" />
            </Helmet>
            <section className="services-header" id="career">
                <div className="bg">
                    <img src={`${base_url_url}service-bottom-left.png`} alt="Background Layer" title="Background Layer" width="auto" height="auto" className="bottom-left" />
                    <img src={`${base_url_url}service-top-right.png`} alt="Background Layer" title="Background Layer" width="auto" height="auto" className="top-right" />
                </div>
                <div className="container">
                    <div className="row">
                        <div className="content-section">
                            <h2>Career</h2>
                        </div>
                    </div>
                </div>
            </section>
            <section className='careerInfo'>
                <div className='container'>
                    <div className='careerSingle'>
                        <h2><i className={`fa ${icon}`}></i>{title} <Link to="/career/"><i className='fa fa-chevron-left'></i> back to Career</Link></h2>
                        <div className='meta'>
                            <p><strong>Experience:</strong>{experience}</p>
                            <p><strong>Location:</strong>{location}</p>
                        </div>
                        <div className=''>
                            <h3>Skills Required</h3>
                            <ul className='skillist'>
                                {
                                    loading ? skills.map((item) => <li>{item}</li>) : ""
                                }
                            </ul>
                        </div>


                        <form onSubmit={sendEmail} className='form'>
                            <h2>Apply Now for {title}</h2>
                            <div className='three-column'>
                                <input type="text" value={formName} onChange={(e) => setName(e.target.value)} placeholder="Name" required />
                                <input type="email" value={formEmail} onChange={(e) => setEmail(e.target.value)} placeholder="Email" required />
                            </div>

                            <input type="text" value={formPhone} onChange={(e) => setPhone(e.target.value)} placeholder="Phone" required /> <br />

                            <select value={formHearAbout} onChange={(e) => setHearAoout(e.target.value)} required>
                                <option>How Did You Hear About Us</option>
                                <option value="Search Engine">Search Engine</option>
                                <option value="GoodFirms">GoodFirms</option>
                                <option value="Social Media Platform">Social Media Platform</option>
                                <option value="Word of Mouth">Word of Mouth</option>
                                <option value="Other">Other</option>
                            </select>
                            Upload Resume
                            <input type="file" onChange={fileChangeHandler} required />
                            <textarea value={formExperience} onChange={(e) => setExperience(e.target.value)} placeholder="Experience" required/><br />
                            <button type="submit" value="Submit Now" className='submit-btn' >SUBMIT NOW</button>
                            {
                                formLoading? <p className='progress'><i className='fa fa-spinner'></i></p>: <p dangerouslySetInnerHTML={ {__html: formmessage} } />
                            }
                        </form>
                    </div>
                </div>
            </section>
        </>

    )
}

export default SingleCareer;